import {addSegmentScript} from './segment/addSegmentScript';
import {trackCancellationButtonClicks} from './segment/trackCancellationButtonClicks';

export function initializeSegment({segmentKey, userId, userEmail}) {
  if (!segmentKey) {
    console.warn('Segment.com was not initialized because API key was not set.');
    return;
  }

  if (!userId) {
    // do not track anonymous users
    return;
  }

  addSegmentScript({segmentKey, userId, userEmail});
  trackCancellationButtonClicks();
}
